import { render, staticRenderFns } from "./intern.vue?vue&type=template&id=4bcfe08a&"
import script from "./intern.vue?vue&type=script&lang=js&"
export * from "./intern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports